import React, { useState } from "react";

function ProjectMaster() {

  const [formData, setFormData] = useState({
    projectName: "",
    clientName: "",
    projectType: "",
    budget: "",
    startDate: "",
    endDate: "",
    location: "",
    description: "",
    status: ""
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData.projectName) tempErrors.projectName = "Project Name is required";
    if (!formData.clientName) tempErrors.clientName = "Client Name is required";
    if (!formData.projectType) tempErrors.projectType = "Select Project Type";
    if (!formData.budget) tempErrors.budget = "Budget is required";
    if (!formData.startDate) tempErrors.startDate = "Start Date required";
    if (!formData.status) tempErrors.status = "Select Status";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      alert("Project Saved Successfully!");
      console.log(formData);
    }
  };

  const handleReset = () => {
    setFormData({
      projectName: "",
      clientName: "",
      projectType: "",
      budget: "",
      startDate: "",
      endDate: "",
      location: "",
      description: "",
      status: ""
    });
    setErrors({});
  };

  return (
    <div>
      <h3 className="mb-4 gold-text">Project Master</h3>

      <div className="card p-4">
        <form onSubmit={handleSubmit}>

          <div className="row">

            {/* Project Name */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Project Name *</label>
              <input
                type="text"
                className="form-control"
                name="projectName"
                value={formData.projectName}
                onChange={handleChange}
              />
              {errors.projectName && <small className="text-danger">{errors.projectName}</small>}
            </div>

            {/* Client Name */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Client Name *</label>
              <input
                type="text"
                className="form-control"
                name="clientName"
                value={formData.clientName}
                onChange={handleChange}
              />
              {errors.clientName && <small className="text-danger">{errors.clientName}</small>}
            </div>

            {/* Project Type */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Project Type *</label>
              <select
                className="form-select"
                name="projectType"
                value={formData.projectType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="Residential">Residential</option>
                <option value="Commercial">Commercial</option>
                <option value="Villa">Villa</option>
                <option value="Office">Office</option>
              </select>
              {errors.projectType && <small className="text-danger">{errors.projectType}</small>}
            </div>

            {/* Budget */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Budget (₹) *</label>
              <input
                type="number"
                className="form-control"
                name="budget"
                value={formData.budget}
                onChange={handleChange}
              />
              {errors.budget && <small className="text-danger">{errors.budget}</small>}
            </div>

            {/* Start Date */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Start Date *</label>
              <input
                type="date"
                className="form-control"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
              />
              {errors.startDate && <small className="text-danger">{errors.startDate}</small>}
            </div>

            {/* End Date */}
            <div className="col-md-6 mb-3">
              <label className="form-label">End Date</label>
              <input
                type="date"
                className="form-control"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
              />
            </div>

            {/* Location */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Site Location</label>
              <input
                type="text"
                className="form-control"
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
            </div>

            {/* Status */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Status *</label>
              <select
                className="form-select"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="">Select Status</option>
                <option value="Active">Active</option>
                <option value="Completed">Completed</option>
              </select>
              {errors.status && <small className="text-danger">{errors.status}</small>}
            </div>

            {/* Description */}
            <div className="col-md-12 mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows="3"
                name="description"
                value={formData.description}
                onChange={handleChange}
              ></textarea>
            </div>

          </div>

          {/* Buttons */}
          <div className="text-end">
            <button type="button" className="btn btn-secondary me-2" onClick={handleReset}>
              Reset
            </button>
            <button type="submit" className="btn btn-warning">
              Save Project
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default ProjectMaster;
